import { render } from "./Contact.vue?vue&type=template&id=3c599365&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=3c599365&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c599365"]])

export default __exports__